import React, { useState } from 'react';
import { Flag, LifeBuoy, Sparkles, ShieldAlert, MessageSquareReply } from 'lucide-react';
import AdminReports from './AdminReports';
import AdminTickets from './AdminTickets';
import AdminStories from './AdminStories';
import { AdminSpamLog, AdminMemberReplies } from './AdminSpamLog';

export const fmtDate = (d) => (d ? new Date(d).toLocaleString() : '—');

export const StatusPill = ({ status }) => {
  const tone = {
    open: 'bg-amber-100 text-amber-800', reviewing: 'bg-blue-100 text-blue-800', in_progress: 'bg-blue-100 text-blue-800',
    resolved: 'bg-green-100 text-green-800', dismissed: 'bg-gray-200 text-gray-700', closed: 'bg-gray-200 text-gray-700',
  }[status] || 'bg-gray-100 text-gray-700';
  return <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${tone}`} data-testid={`status-pill-${status}`}>{String(status).replace('_', ' ')}</span>;
};

export const StatusFilter = ({ value, onChange, options, testId }) => (
  <div className="flex flex-wrap gap-2" data-testid={testId}>
    {options.map((o) => (
      <button key={o} type="button" onClick={() => onChange(o)} data-testid={`${testId}-${o}`}
        className={`px-3 py-1 rounded-full text-sm border transition-colors ${value === o ? 'bg-purple-600 text-white border-purple-600' : 'bg-white text-gray-700 border-gray-300 hover:border-purple-400'}`}>
        {o.replace('_', ' ')}
      </button>
    ))}
  </div>
);

export const HistoryList = ({ items }) => (
  <ol className="space-y-1 text-xs text-gray-600" data-testid="history-list">
    {(!items || items.length === 0) && <li className="text-gray-400">No status changes yet.</li>}
    {(items || []).map((h, i) => (
      <li key={i}>
        <span className="text-gray-400">{fmtDate(h.at)}</span> · <b>{h.admin_username}</b>: {h.from_status || '—'} → {h.to_status}
        {h.action_on_user && h.action_on_user !== 'none' && <span className="text-red-600"> · user {h.action_on_user}</span>}
        {h.note && <span className="italic"> — {h.note}</span>}
      </li>
    ))}
  </ol>
);

const AdminModeration = ({ onOpenMember }) => {
  const [view, setView] = useState('reports');
  return (
    <div className="space-y-6" data-testid="admin-moderation">
      <div className="flex items-center gap-2 border-b border-gray-200">
        {[{ id: 'reports', label: 'Reports', icon: Flag }, { id: 'tickets', label: 'Support Tickets', icon: LifeBuoy }, { id: 'stories', label: 'Member Stories', icon: Sparkles }, { id: 'replies', label: 'Member Replies', icon: MessageSquareReply }, { id: 'spam', label: 'Spam Log', icon: ShieldAlert }].map(({ id, label, icon: Icon }) => (
          <button key={id} type="button" onClick={() => setView(id)} data-testid={`moderation-subtab-${id}`}
            className={`flex items-center px-4 py-2 -mb-px border-b-2 text-sm font-medium ${view === id ? 'border-purple-500 text-purple-700' : 'border-transparent text-gray-500 hover:text-gray-700'}`}>
            <Icon className="w-4 h-4 mr-2" />{label}
          </button>
        ))}
      </div>
      {view === 'reports' && <AdminReports />}
      {view === 'tickets' && <AdminTickets onOpenMember={onOpenMember} />}
      {view === 'stories' && <AdminStories />}
      {view === 'replies' && <AdminMemberReplies onOpenMember={onOpenMember} />}
      {view === 'spam' && <AdminSpamLog />}
    </div>
  );
};

export default AdminModeration;
